// Copyright (c) 2021 Deere & Company

import './index.scss';
import AuditLog from './auditlog';

import AuthenticatedPage from '../../common/components/authenticated-page';
import React from 'react';

function AuditLogPage () {

    return (
        <AuthenticatedPage className="atp-page auditlog-page">
            <AuditLog />
        </AuthenticatedPage>
    );

}
AuditLogPage.displayNAme = 'AuditLogPage';

export default AuditLogPage;
